import ArtistEngine from './ArtistEngine';

const Index = () => {
  return <ArtistEngine />;
};

export default Index;
